import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pl-6 vertical-line" }
const _hoisted_2 = { class: "cursor-pointer text-xl horizontal-line" }
const _hoisted_3 = {
  key: 0,
  class: "pl-6 vertical-line"
}

import { computed, ref, watch } from "vue";
import TreeItemInterface from "@/types/TreeItemInterface";
import { TreeItem } from "@/components/common/index";
import {
  DocumentIcon,
  FolderIcon,
  FolderOpenIcon,
} from "@heroicons/vue/outline";


export default /*#__PURE__*/_defineComponent({
  props: {
    item: null,
    setParentId: null,
    activeId: null
  },
  setup(__props: any) {

const props = __props as {
  item: TreeItemInterface;
  setParentId: (childParentId: string) => void;
  activeId: string;
}



const isOpen = ref(true);

const isFolder = computed(
  () => props.item.children && props.item.children.length
);

const toggle = (childParentId: string) => {
  props.setParentId(childParentId);
  if (isFolder.value) {
    isOpen.value = !isOpen.value;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center p-1", __props.item.id === __props.activeId ? 'item-active' : '']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => {
          toggle(__props.item.id);
          _ctx.$emit('select', __props.item);
        })
      }, [
        _withDirectives(_createVNode(_unref(DocumentIcon), { class: "w-7 h-7 mr-3 inline" }, null, 512), [
          [_vShow, !_unref(isFolder)]
        ]),
        _withDirectives(_createVNode(_unref(FolderIcon), { class: "w-7 h-7 mr-3 inline" }, null, 512), [
          [_vShow, !isOpen.value && _unref(isFolder)]
        ]),
        _withDirectives(_createVNode(_unref(FolderOpenIcon), { class: "w-7 h-7 mr-3 inline" }, null, 512), [
          [_vShow, isOpen.value && _unref(isFolder)]
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(__props.item.name), 1)
        ])
      ], 2),
      (_unref(isFolder))
        ? _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (child, index) => {
              return (_openBlock(), _createBlock(_unref(TreeItem), {
                key: index,
                item: child,
                setParentId: __props.setParentId,
                "active-id": __props.activeId,
                onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select', $event)))
              }, null, 8, ["item", "setParentId", "active-id"]))
            }), 128))
          ], 512)), [
            [_vShow, isOpen.value]
          ])
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})